import * as actionTypes from '../../../constants/actionTypes';
import { getApiConfig } from '../../../utilities/index';
import { loadingDialog_show, errorBox_Show } from '../../../actions/A_Popups';
import uuid from 'uuid';

const AT = "-" + uuid.v4();

export const toggleShowAssignFeature = () => {
    return  { type: actionTypes.SKU_FILTER_RELATIONSHIP_OPEN_ASSIGN_FEATURE_POPUP }; 
}